// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aas-section-header-field {
  width: 100%;
}
.aas-section-header-field .mat-mdc-form-field-wrapper {
  background-color: #bbdff9;
  filter: brightness(1.06);
  padding: 0.75rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
}
.aas-section-header-field .mat-mdc-form-field-flex {
  display: flex;
  align-items: center;
}
.aas-section-header-field .mat-mdc-form-field-infix {
  display: flex;
  align-items: center;
  min-height: auto;
}
.aas-section-header-field mat-label {
  font-size: 1.25rem !important;
  color: #333 !important;
}
.aas-section-header-field .mdc-floating-label {
  font-weight: bold !important;
  font-size: 1.25rem !important;
}
.aas-section-header-field .mat-mdc-form-field-label {
  font-weight: bold !important;
  font-size: 1.25rem !important;
}
.aas-section-header-field .mat-mdc-form-field-suffix {
  display: flex;
  align-items: center;
  height: 100%;
}
.aas-section-header-field button[matSuffix] {
  align-self: center;
  margin-left: 8px;
}

.aas-section-header-input {
  font-weight: bold;
  font-size: 1.25rem;
}

.mat-divider {
  border-top-width: 2px !important;
  border-top-color: #333 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/claims-app/concern-cause-component-list/concern-cause-component-list.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AACE;EACE,yBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AADJ;AAIE;EACE,6BAAA;EACA,sBAAA;AAFJ;AAKE;EACE,4BAAA;EACA,6BAAA;AAHJ;AAME;EACE,4BAAA;EACA,6BAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AALJ;AAQE;EACE,kBAAA;EACA,gBAAA;AANJ;;AAUA;EACE,iBAAA;EACA,kBAAA;AAPF;;AAUA;EACE,gCAAA;EACA,iCAAA;AAPF","sourcesContent":[".aas-section-header-field {\r\n  width: 100%;\r\n\r\n  .mat-mdc-form-field-wrapper {\r\n    background-color: #bbdff9;\r\n    filter: brightness(1.06);\r\n    padding: 0.75rem;\r\n    margin-bottom: 1rem;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .mat-mdc-form-field-flex {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .mat-mdc-form-field-infix {\r\n    display: flex;\r\n    align-items: center;\r\n    min-height: auto;\r\n  }\r\n\r\n  mat-label {\r\n    font-size: 1.25rem !important;\r\n    color: #333 !important;\r\n  }\r\n\r\n  .mdc-floating-label {\r\n    font-weight: bold !important;\r\n    font-size: 1.25rem !important;\r\n  }\r\n\r\n  .mat-mdc-form-field-label {\r\n    font-weight: bold !important;\r\n    font-size: 1.25rem !important;\r\n  }\r\n\r\n  .mat-mdc-form-field-suffix {\r\n    display: flex;\r\n    align-items: center;\r\n    height: 100%;\r\n  }\r\n\r\n  button[matSuffix] {\r\n    align-self: center;\r\n    margin-left: 8px;\r\n  }\r\n}\r\n\r\n.aas-section-header-input {\r\n  font-weight: bold;\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.mat-divider {\r\n  border-top-width: 2px !important;\r\n  border-top-color: #333 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
